/* tslint:disable */
/* eslint-disable */
export enum RoleDto {
  Administrator = 'ADMINISTRATOR',
  Manager = 'MANAGER',
  Expert = 'EXPERT',
  ConsignmentManager = 'CONSIGNMENT_MANAGER',
  User = 'USER'
}
